var _g, _g2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";
import { forwardRef } from "react";

var SvgPaperPlane = function SvgPaperPlane(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 105,
    height: 93,
    viewBox: "0 0 105 93",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_279_2146)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_279_2146)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.0806 54.1963L22.3017 75.41L37.0151 61.8074L95.3832 34.9339L28.0806 54.1963Z",
    fill: "#9B6BFF",
    stroke: "#010101",
    strokeOpacity: 0.4,
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.439 66.4419L22.3098 75.4204L37.0232 61.8179L39.439 66.4419Z",
    fill: "#8246FF",
    stroke: "#010101",
    strokeOpacity: 0.4,
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.0145 61.8151L95.3827 34.9416L50.044 87.2542L37.0145 61.8151Z",
    fill: "#BC9BFF",
    stroke: "#010101",
    strokeOpacity: 0.4,
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.0852 54.1984L1.71534 40.1355L95.3879 34.936L28.0852 54.1984Z",
    fill: "#BC9BFF",
    stroke: "#010101",
    strokeOpacity: 0.4,
    strokeWidth: 0.3
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_279_2146)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.9328 21.0885C59.0875 23.2735 64.6616 28.8879 63.4234 33.7571L63.3743 33.7854C63.1716 34.5933 62.7912 35.3457 62.2607 35.9878C59.5357 39.2123 53.0233 40.4168 46.251 38.5607C44.1445 38.0063 42.1213 37.1736 40.2347 36.0846C36.6047 33.9737 34.1609 31.1256 33.6572 28.3237C33.5128 27.587 33.5209 26.8286 33.6811 26.0952L33.8057 25.6301C35.2939 20.9443 42.8711 18.9285 50.9328 21.0885ZM38.1821 25.6064C37.9179 25.9919 37.7217 26.4198 37.6022 26.8717C36.6426 30.4529 40.7958 34.673 46.873 36.3013C52.9503 37.9297 58.619 36.3081 59.6013 32.7662C59.7191 32.3163 59.7599 31.8496 59.7218 31.3861C59.4823 28.1565 55.6325 24.7572 50.3304 23.3365C45.0283 21.9158 40.0102 22.9391 38.1765 25.5965L38.1821 25.6064Z",
    fill: "url(#paint0_linear_279_2146)",
    stroke: "#010101",
    strokeWidth: 0.231001,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.1755 25.5983C37.9112 25.9838 37.715 26.4118 37.5955 26.8636C36.6359 30.4449 40.7891 34.6649 46.8664 36.2933C52.9437 37.9217 58.618 36.3099 59.6003 32.768C59.7181 32.3181 59.7589 31.8514 59.7209 31.3879C59.4813 28.1583 55.6316 24.759 50.3294 23.3383C45.0273 21.9176 40.0092 22.9409 38.1755 25.5983Z",
    fill: "#ECA124"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.6903 26.0984L32.4441 30.7493C31.7381 34.0662 34.1999 37.8082 38.5194 40.4776L40.2285 36.0836C36.5985 33.9727 34.1547 31.1246 33.6509 28.3227C33.5122 27.5863 33.5256 26.8294 33.6903 26.0984Z",
    fill: "#ECA124",
    stroke: "#010101",
    strokeWidth: 0.231001,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.2327 36.0926L38.5236 40.4867C40.538 41.7105 42.719 42.6363 44.9986 43.2352C53.1378 45.416 60.7653 43.3057 62.1589 38.5696L62.2005 38.4146L63.4006 33.8426C63.1828 34.6356 62.793 35.3708 62.2587 35.9959C59.5336 39.2204 53.0213 40.4249 46.249 38.5687C44.1425 38.0143 42.1192 37.1816 40.2327 36.0926Z",
    fill: "#FFB63D",
    stroke: "#010101",
    strokeWidth: 0.231001,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.0923 31.2381C50.6188 31.3977 51.1714 31.4527 51.7189 31.3998C52.2173 31.3637 52.7016 31.2183 53.1374 30.974C53.3751 30.8668 53.5687 30.681 53.6855 30.4479C53.7211 30.3669 53.733 30.2775 53.7196 30.19C53.7063 30.1026 53.6683 30.0207 53.6101 29.9541C53.4326 29.7664 53.2086 29.629 52.9608 29.5558C52.7202 29.4549 52.4662 29.3896 52.2068 29.3621C51.9465 29.3341 51.6839 29.3362 51.4241 29.3684C51.1751 29.3945 50.9279 29.4365 50.6842 29.4941L50.0544 29.6743L49.0858 29.9714C48.7457 30.0808 48.3997 30.1712 48.0495 30.2421C47.6492 30.3282 47.2428 30.3832 46.834 30.4066C46.3866 30.4293 45.938 30.4119 45.4937 30.3548C44.9998 30.2981 44.5156 30.1767 44.0534 29.9938C43.5569 29.8388 43.1026 29.5721 42.7253 29.2142C42.6035 29.0959 42.5179 28.9455 42.4783 28.7805C42.4387 28.6154 42.4467 28.4425 42.5015 28.2819C42.716 27.8505 43.0723 27.5059 43.5107 27.3061C44.0569 26.9941 44.6495 26.7714 45.266 26.6465C45.9282 26.5185 46.6041 26.4763 47.277 26.5207C47.9737 26.5795 48.6612 26.7191 49.3257 26.9367L48.1757 27.6007C47.779 27.4775 47.3679 27.4064 46.9529 27.3893C46.5704 27.3796 46.1882 27.4196 45.816 27.5084C45.4823 27.5856 45.1611 27.7092 44.8618 27.8758C44.6183 27.9999 44.4147 28.1901 44.2744 28.4246C44.2319 28.5137 44.2148 28.6127 44.2252 28.7108C44.2356 28.809 44.273 28.9023 44.3332 28.9804C44.5213 29.2002 44.772 29.3572 45.0517 29.4305C45.3601 29.5458 45.6851 29.6104 46.0141 29.6219C46.3449 29.6289 46.6756 29.6006 47.0005 29.5373C47.3366 29.4612 47.6825 29.3794 48.0367 29.2666L49.2303 28.9051C50.006 28.6663 50.8103 28.5325 51.6216 28.5074C52.4137 28.4803 53.2033 28.6127 53.9432 28.8969C54.4379 29.0451 54.8855 29.3197 55.2418 29.6935C55.3574 29.8119 55.4365 29.961 55.4697 30.1231C55.5028 30.2852 55.4887 30.4534 55.4289 30.6076C55.2434 30.9974 54.9305 31.3121 54.5418 31.4999C54.026 31.7921 53.4635 31.9928 52.8792 32.0929C52.2452 32.2148 51.598 32.2537 50.9539 32.2084C50.3086 32.1705 49.6715 32.0445 49.0603 31.8339L50.0923 31.2381ZM42.5369 26.7544L56.0505 31.7296L55.4804 32.0588L41.9498 27.054L42.5369 26.7544Z",
    fill: "#010101"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_279_2146",
    x1: 101.072,
    y1: 88.3536,
    x2: 51.245,
    y2: 112.463,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#FFD25E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB63D"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_279_2146"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 104.772,
    height: 92.4004,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_279_2146"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 83.7225,
    height: 64.9681,
    fill: "white",
    transform: "matrix(-0.866025 0.5 0.5 0.866025 74.2212 -1.72296)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_279_2146"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 29.1899,
    height: 29.1902,
    fill: "white",
    transform: "matrix(-0.5 -0.866025 -0.866025 0.5 67.9031 37.5018)"
  })))));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgPaperPlane);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/paper-plane.cc31d42f8874df09ff2c7ff3037fd447.svg";